"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Touch {
    constructor(config) {
        this.listeners = {
            touchStart: [],
            touchMove: [],
            touchEnd: [],
        };
        this._onTouchStart = (event) => {
            // console.log('inner touch start');
            const { touchStart: callbacks } = this.listeners;
            const { element } = this;
            element.addEventListener('touchmove', this._onTouchMove);
            element.addEventListener('touchend', this._onTouchEnd);
            if (callbacks.length) {
                callbacks.forEach((callback) => callback === null || callback === void 0 ? void 0 : callback(event));
            }
        };
        this._onTouchMove = (event) => {
            // console.log('inner touch move');
            const { touchMove: callbacks } = this.listeners;
            if (callbacks.length) {
                callbacks.forEach((callback) => callback === null || callback === void 0 ? void 0 : callback(event));
            }
        };
        this._onTouchEnd = (event) => {
            // console.log('inner touch end');
            const { touchEnd: callbacks } = this.listeners;
            const { element } = this;
            if (callbacks.length) {
                callbacks.forEach((callback) => callback === null || callback === void 0 ? void 0 : callback(event));
            }
            element.removeEventListener('touchmove', this._onTouchMove);
            element.removeEventListener('touchend', this._onTouchEnd);
        };
        this.element = config.element;
        this.addEventListener();
    }
    addEventListener() {
        const { element } = this;
        element.addEventListener('touchstart', this._onTouchStart);
    }
    ;
    onTouchStart(callback) {
        return this.onEventListener('touchStart', callback);
    }
    onTouchMove(callback) {
        return this.onEventListener('touchMove', callback);
    }
    onTouchEnd(callback) {
        return this.onEventListener('touchEnd', callback);
    }
    onEventListener(eventName, callback) {
        if (!eventName || !callback) {
            return false;
        }
        const { [eventName]: callbacks } = this.listeners;
        if (callbacks.find(_callback => _callback.id === callback.id)) {
            return true;
        }
        callback.id = callbacks.length + Date.now();
        callbacks.push(callback);
        return true;
    }
    offTouchStart(callback) {
        return this.offEventListener('touchStart', callback);
    }
    offTouchMove(callback) {
        return this.offEventListener('touchMove', callback);
    }
    offTouchEnd(callback) {
        return this.offEventListener('touchEnd', callback);
    }
    offEventListener(eventName, callback) {
        if (!eventName || !callback) {
            return;
        }
        const { [eventName]: callbacks } = this.listeners;
        const targetIndex = callbacks.findIndex(_callback => _callback.id === callback.id);
        if (targetIndex >= 0) {
            callbacks.splice(targetIndex, 1);
            return true;
        }
        return false;
    }
}
exports.default = Touch;
